import { render } from "./AmountContent.vue?vue&type=template&id=6b9a4cbf&scoped=true&ts=true"
import script from "./AmountContent.vue?vue&type=script&lang=ts"
export * from "./AmountContent.vue?vue&type=script&lang=ts"

import "./AmountContent.vue?vue&type=style&index=0&id=6b9a4cbf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9a4cbf"]])

export default __exports__